import React from 'react';

const ProductCardSkeleton = () => {
  return (
    <div className="bg-white rounded-2xl border border-[#6B4F2A]/10 overflow-hidden animate-pulse">
      {/* Image Skeleton */}
      <div className="aspect-square bg-[#6B4F2A]/10" />

      {/* Content Skeleton */}
      <div className="p-4 space-y-3">
        {/* Category */}
        <div className="h-3 w-16 bg-[#6B4F2A]/10 rounded" />
        
        {/* Name */}
        <div className="h-5 w-3/4 bg-[#6B4F2A]/10 rounded" />
        
        {/* Rating */}
        <div className="flex gap-1">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="w-3 h-3 bg-[#6B4F2A]/10 rounded-full" />
          ))}
        </div>
        
        {/* Price */}
        <div className="h-6 w-24 bg-[#6B4F2A]/10 rounded" />
        
        {/* Weight */}
        <div className="h-3 w-12 bg-[#6B4F2A]/10 rounded" />
      </div>
    </div>
  );
};

export default ProductCardSkeleton;
